import _ from 'lodash';
import ApiService from '../api/ApiService';

export default async function debreifRecord(recordId) {
  const rawResponse = await ApiService(
    'debrifeRecord',
    { recordId },
    null,
    JSON.stringify({
      debriefingTool: 'carcheck',
    }),
  );
  return _.get(rawResponse, 'data.id', '');
}
